import {calculateStatusDatapoints, calculateNumericDatapoints, ToLowerCase} from './asset-dashboard.utility';
import templateService from './templates.service';

export default class DashboardViewModel {
  constructor(equipment) {
    this._id = equipment.id;
    this._status = calculateStatusDatapoints(equipment.onei3.series);
    this._numeric = calculateNumericDatapoints(equipment.onei3.series);
    this._title = equipment.attributes.name;
    this._packageIds = equipment.installation
      ? Array.from(equipment.installation.attributes.packages.map(package_item => package_item.id))
      : null;
    this._runHours = equipment.onei3.series.run_time;
    this._communicatedAt = equipment.communicatedAt;

    const template = templateService(this._packageIds, this._status, this._numeric);

    this._off = template.off;
    this._alarms = template.alarms;
    this._statuses = template.statuses;
    this._dials = template.dials;
    this._dialTemplate = template.templateName;
    this._attrs = ToLowerCase(equipment.attributes.attrs);
  }

  get id() {
    return this._id;
  }

  get off() {
    return this._off;
  }

  get status() {
    return this._status;
  }

  get statuses() {
    return this._statuses;
  }

  get dials() {
    return this._dials;
  }

  get numeric() {
    return this._numeric;
  }

  get alarms() {
    return this._alarms;
  }

  get dialTemplate() {
    return this._dialTemplate;
  }

  get title() {
    return this._title;
  }

  get packageIds() {
    return this._packageIds;
  }

  get runHours() {
    return this._runHours;
  }

  get communicatedAt() {
    return this._communicatedAt;
  }
  get make() {
    return this._attrs['make'];
  }
  get model() {
    return this._attrs['model'];
  }
  get description() {
    return this._attrs['description'];
  }
}
